export const maquetaTpl = {
  modalDatos: {
    regTitle: `Détails de l'enregistrement`,
    paymentMethod: `Mode de paiement`,
    paymentDate: `Date de paiement`,
    guestCount: `Nombre de voyageurs`,
    unspecified: `Non spécifié`,
    pay: {
      DESTI: `Paiement à destination`,
      EFECT: `Espèces`,
      MOVIL: `Paiement mobile`,
      OTRO: `Autres modes de paiement`,
      PLATF: `Plateforme de paiement`,
      TARJT: `Carte de crédit`,
      TRANS: `Virement bancaire`,
      TREG: `Carte cadeau`,
    },
  },
  whatsapp: {
    title: `Accès exclusif à WhatsApp Business`,
    body: `Pour utiliser la fonctionnalité WhatsApp Business, un abonnement WhatsApp Business Personal actif est requis. Cette option est conçue pour vous offrir des outils supplémentaires et des fonctionnalités avancées afin d'améliorer votre expérience professionnelle.`,
  },
  nav: {
    welcome: `Bienvenue`,
    manager: `Gestionnaire`,
    logout: `Se déconnecter`,
    logoutError: `Désolé, une erreur s'est produite lors de la déconnexion`,
  },
  subnav: {
    home: `Accueil`,
    clients: `Clients`,
    prices: `Tarifs`,
    payments: `Paiements`,
    userManagement: `Gestion des utilisateurs`,
  },
};
